import React, { FC } from "react";
import styles from "./padding.module.scss";

const Padding: FC = ({ children }) => (
	<div className={styles.padding}>{children}</div>
);

export default Padding;
